import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IComplaint } from 'app/models/complaint/complaint';
import { IComplaintContractor } from 'app/models/complaint/complaintContractor';
import { AddEditAssociationComponent } from '../add-edit-association/add-edit-association.component';
import { ComplaintService } from 'app/services/complaint/complaint.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogueComponent } from 'app/components/application/common/confirmation-dialogue/confirmation-dialogue.component';
import { SharedService } from 'app/services/core/shared.service';

@Component({
  selector: 'app-add-edit-contractor',
  templateUrl: './add-edit-contractor.component.html',
  styleUrls: ['./add-edit-contractor.component.scss']
})
export class AddEditContractorComponent implements OnInit {
  public contractorDataForm = new UntypedFormGroup({
    name: new UntypedFormControl("", [Validators.required]),
    ccb: new UntypedFormControl("", [Validators.maxLength(50)]),
    phone: new UntypedFormControl("", [Validators.maxLength(50)]),
    email: new UntypedFormControl("", [Validators.maxLength(255)]),
    street: new UntypedFormControl("", [Validators.maxLength(255)]),
    city: new UntypedFormControl("", [Validators.maxLength(255)]),
    state: new UntypedFormControl("", [Validators.maxLength(2)]),
    zip: new UntypedFormControl("", [Validators.maxLength(20)])
  });
  public contractorData: IComplaintContractor = null;

  constructor(
    private readonly dialogRef: MatDialogRef<AddEditAssociationComponent>,
    @Inject(MAT_DIALOG_DATA) public data:{complaintId:number, contractor:IComplaintContractor},
    private readonly toastr: ToastrService,
    public complaintService: ComplaintService,
    public sharedService: SharedService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(){
    if(this.data.contractor !== null){
      this.contractorData = this.data.contractor;         
    }
    else{
      this.contractorData = {
        id: 0,       
        complaintId: this.data.complaintId,
        name: '',
        ccb: '',
        phone: '',
        email: '',
        street: '',
        city: '',
        state: '',
        zip: ''        
      };     
    }

    for (const controlName in this.contractorData) {
      if (this.contractorDataForm.controls.hasOwnProperty(controlName)) {
        this.contractorDataForm.controls[controlName].setValue(this.contractorData[controlName]);
      }
    }    
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onSubmit(): void {    
    const dialogRef = this.dialog.open(ConfirmationDialogueComponent, {
      width: '400px',
      data: {message:'Are you sure you want to save the Complaint Contractor: <strong>' + this.contractorDataForm.controls.name.value + '</strong>?', title: 'Save Contractor'},});
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.saveContractor();
      }
    })  
  }

  saveContractor(): void {
    for (const controlName in this.contractorDataForm.controls) {
      if (this.contractorData.hasOwnProperty(controlName)) {
        this.contractorData[controlName] = this.contractorDataForm.controls[controlName].value;
      }
    }      
    this.complaintService.saveComplaintContractor(this.contractorData).subscribe({
      next: () => {
        this.toastr.success('Contractor saved successfully.', 'Success');
        this.dialogRef.close(true);
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('An error occurred while saving the contractor.', 'Error');
      }
    });
  }
}
